import { Text } from 'components';
import { theme } from 'lib';
import { useRef } from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';

import 'react-datepicker/dist/react-datepicker.css';

const Wrapper = styled.div`
  .react-datepicker {
    border: 0;
  }

  .react-datepicker__header {
    background-color: transparent;
    border: 0;
  }

  .react-datepicker__day-names {
    margin-top: 10px;
    width: calc(100% - 20px);
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
  }

  .react-datepicker__day-name {
    color: ${theme.GREY_60};
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    font-family: CeraPro;
  }

  .react-datepicker__day {
    padding: 3px;
    background-color: ${theme.GREY_10};
    border-radius: 100%;
  }

  .react-datepicker__day--selected {
    background-color: ${theme.SECONDARY};
  }

  .react-datepicker__day--in-range {
    background-color: ${theme.SECONDARY};
  }

  .react-datepicker__day--in-selecting-range {
    background-color: ${theme.SECONDARY_20};

    p {
      color: #000;
    }
  }

  .react-datepicker__day--outside-month {
    background-color: transparent;

    p {
      color: ${theme.GREY_30};
    }
  }

  .react-datepicker__month-year-read-view--selected-month-year {
    font-weight: bold;
    font-family: CeraPro;
    font-size: 1rem;
    margin-right: 10px;
  }

  .react-datepicker__month-year-read-view {
    visibility: visible !important;
  }

  .react-datepicker__year-dropdown {
    background-color: #fff;
    border: none;
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    padding: 11px 6px;
    height: 200px;
    overflow-y: scroll;
  }

  .react-datepicker__year-option {
    font-family: CeraPro;
    font-weight: 500;
    font-size: 16px;
  }

  .react-datepicker__year-option--selected_year {
    font-family: CeraPro;
    color: ${theme.SECONDARY};
    font-weight: 500;
  }

  .react-datepicker__year-option--selected {
    display: none;
  }

  .react-datepicker__year-read-view--down-arrow {
    display: none;
  }

  .react-datepicker__year-read-view {
    cursor: pointer;
    width: 120px;
    top: -18px;
    opacity: 0;
  }
`;

const CustomCalendar = (props) => {
  const pickerRef = useRef(null);

  return (
    <Wrapper className="date-picker">
      <DatePicker
        {...props}
        ref={pickerRef}
        inline
        disabledKeyboardNavigation
        renderDayContents={(day, date) => (
          <Text b1 med center>
            {day}
          </Text>
        )}
      />
    </Wrapper>
  );
};

export default CustomCalendar;
